const getActualValueFromDSL = (value: string | undefined): string => {
  if (!value) return '';
  try {
    return value.split('::').pop()?.replace(/"/g, '') || '';
  } catch (error) {
    console.error('Error in getActualValueFromDSL', error);
    return '';
  }
};

export default getActualValueFromDSL;
